module.exports = __webpack_public_path__ + "static/img/kuaishouERcode.a831f122.jpg";